import { SpwnApiResponse, SpwnService } from "@spwn-portal/grpc";
/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
/* eslint-enable no-restricted-imports */

import appConfig from "../constants/appConfig";
import { createConnectClient } from "../utility/connectWeb";
import { fetchFbToken } from "../utility/firebase";

export const callConfirmCharge = async () => {
  const fbToken = await fetchFbToken();
  if (!fbToken) return;

  // @ts-expect-error TS2769
  const response = await fetch(appConfig.PaymentSystem.confirmCharge, {
    method: "GET",
    headers: { Authorization: `'Bearer ${fbToken}` },
  });
  // TODO: 新APIをここで呼ぶ
  return response;
};

export const callUsePAW = async (msg: {
  eid: string;
  itemId: string;
  freePrice: number;
  paidPrice: number;
  count: number;
  orderId: string | null;
  giftPlaces: string[] | null;
  displayValue: number | null;
}) => {
  try {
    const auth = firebase.auth();
    const userId = auth.currentUser?.uid;
    if (!userId) {
      console.error("UsePaw: User not authed!");
      return;
    }
    const connectClient = createConnectClient(SpwnService);
    const response = await connectClient.usePawValue({
      itemId: msg.itemId,
      eventId: msg.eid,
      firestoreOrderId: msg.orderId ?? undefined,
      giftPlaces: msg.giftPlaces ?? [],
    });
    if (response.status !== SpwnApiResponse.SUCCESS) {
      throw new Error(`Failed usePaw:${response.status}`);
    }
    return new Response();
  } catch (e) {
    console.error(e);
    return new Response("", { status: 400 });
  }
};
